<template lang="pug">
#IngresarPago
  b-button(variant="action" @click="showModal = true;")
    | Ingresar Pago en OV Rechazada
  ModalPayment(
    :showModal="showModal" 
    :item="this.dataOv"
    inRejectedStatus 
    @close="onClose"
  )
</template>
<script>
import ModalPayment from '../../ModalPayment.vue';

export default {
  name: 'IngresarPago',
  components: {
    ModalPayment
  },
  props: {
    dataOv: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showModal: false

    }
  },
  methods: {
    onClose() {
      this.$emit('reloadAll');
      this.showModal = false;
    }
  }

}
</script>
